module.exports = {
  email: 'nsalunke@charlotte.edu',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/Niwant',
    },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/_niwantsalunke_',
    },
    {
      name: 'Twitter',
      url: 'https://leetcode.com/u/Niwant/',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/niwantsalunke',
    },
    // {
    //   name: 'Codepen',
    //   url: 'https://codepen.io/bchiang7',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Work',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#C73E1D',
    navy: '#0A0A0A',
    darkNavy: '#1A1A1A',
    japaneseRed: '#C73E1D',
    japaneseGold: '#D4AF37',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
